import { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { InputSelect } from "../../../../components/formComponents/inputSelect";
import { InputFecha } from "../../../../components/formComponents/InputFecha";
import { DataContext } from "../../../../contextData/contextData";
import ErrorInput from "../../../../components/ui/ErrorInput";
import { TIPO_CONTRATO } from "../../../../utils/Constants";
import { FIELD_LABEL_STYLE } from "../ModalEditarSolicitud";

export const EditarCambioContrato = ({ formik, solicitud }) => {
  const { uno } = useContext(DataContext);
  const tipoContratoActual =
    solicitud?.persona?.tipo_contrato ||
    solicitud?.persona?.REEO_NRO_TIPO_CONTRATO ||
    uno?.["REEO_NRO_TIPO_CONTRATO"];

  const rtnListadoTipoContrato = (arr, tipo) =>
    ["02", "2", 2].includes(tipo)
      ? [{ value: "01", label: "Cambiar estatus a indefinido" }]
      : arr;

  const currentTipoCambio = String(formik.values.tipo_cambio_contrato || "").trim();

  useEffect(() => {
    if (!["02", "2"].includes(currentTipoCambio)) {
      if (formik.values.fecha_renovacion_contrato) {
        formik.setFieldValue("fecha_renovacion_contrato", "");
      }
    }
  }, [currentTipoCambio]);

  return (
    <>
      <div>
        <InputSelect
          label="NUEVO ESTATUS CONTRATO *"
          labelStyle={FIELD_LABEL_STYLE}
          llave_texto="label"
          llave_valor="value"
          arr={rtnListadoTipoContrato(
            TIPO_CONTRATO,
            tipoContratoActual
          )}
          id="tipo_cambio_contrato"
          formik={formik}
          menuPlacement="auto"
        />
        {formik.errors.tipo_cambio_contrato !== undefined &&
          formik.touched.tipo_cambio_contrato !== undefined && (
            <ErrorInput
              touched={formik.touched.tipo_cambio_contrato}
              error={formik.errors.tipo_cambio_contrato}
            />
          )}
      </div>

      {["02", "2"].includes(currentTipoCambio) && (
        <InputFecha
          formik={formik}
          label="FECHA EXTENSIÓN DE PLAZO FIJO *"
          labelStyle={FIELD_LABEL_STYLE}
          id="fecha_renovacion_contrato"
        />
      )}
    </>
  );
};

EditarCambioContrato.propTypes = {
  formik: PropTypes.object.isRequired,
  solicitud: PropTypes.object,
};
